import { AiOutlineInfoCircle } from 'react-icons/ai';
import { REPORT_NAMINGS, REPORT_TYPES } from '../../../../../../../consts/reportTypes';

const noop = () => {};

export default function UniqueWarning({
  isAif = false,
  isAifm = false,
  onClick = noop,
  reportType
}) {
  const getWarningMessage = () => {
    if (reportType === REPORT_TYPES.FORM_PF) return 'Manager and Fund SEC IDs must be unique.';

    return (
      <>
        All {REPORT_NAMINGS.PROJECT?.[reportType]} and {REPORT_NAMINGS.FUND?.[reportType]} National
        Codes must be unique.
      </>
    );
  };

  return (
    <span
      onClick={onClick}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        color: '#1279e8',
        fontSize: 12,
        lineHeight: 1.2,
        cursor: onClick === noop ? 'default' : 'pointer'
      }}
    >
      <AiOutlineInfoCircle size={13} />
      {getWarningMessage()}
    </span>
  );
  // else if (isAif)
  //   return (
  //     <Badge type="button" onClick={onClick}>
  //       <WarningIcon />

  //       <span>All AIF National Codes must be unique.</span>
  //     </Badge>
  //   );
  // else if (isAifm)
  //   return (
  //     <Badge type="button" onClick={onClick}>
  //       <WarningIcon />

  //       <span>All AIFM National Codes must be unique.</span>
  //     </Badge>
  //   );

  // return <></>;
}
